import { render, staticRenderFns } from "./childProduct.vue?vue&type=template&id=6294db30&scoped=true"
import script from "./childProduct.vue?vue&type=script&lang=js"
export * from "./childProduct.vue?vue&type=script&lang=js"
import style0 from "./childProduct.vue?vue&type=style&index=0&id=6294db30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6294db30",
  null
  
)

export default component.exports